
























































import Vue, { PropType } from 'vue';
import Button from '@/components/form/Button.vue';
import ValidHint from '@/components/hints/ValidHint.vue';
import { ICollectionTabsData } from '@/types';
import filterParams from '@/components/table/utils/filterParameters';

export default Vue.extend({
  name: 'Tabs',
  components: { Button, ValidHint },
  props: {
    tabsData: {
      type: Object as PropType<ICollectionTabsData>,
      required: true,
    },
    activeTab: {
      type: String,
      default: '',
    },
    validation: {
      type: Boolean,
      default: false,
    },
    tabClass: {
      type: String,
      default: '',
    },
    headerClass: {
      type: String,
      default: '',
    },
    loadData: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  created() {
    const urlTab = this.$route.query['tab'] as string;
    if (urlTab) {
      this.currentTab = urlTab;
      this.checkIsActivated(urlTab);
      this.tabIndex = this.tabsListName.indexOf(urlTab);
      return;
    }
    this.currentTab = this.activeTab;
    this.setTabToUrl(this.activeTab);
  },

  watch: {
    activeTab(activeTab: string) {
      this.currentTab = activeTab;
    },
    currentTab(tab: string) {
      if (tab) {
        this.setTabToUrl(tab);
      }
    },
    $route() {
      this.changeTab(this.$route.query.tab as string);
    },
  },

  computed: {
    tabsName(): ICollectionTabsData | null {
      return this.tabsData || null;
    },
    tabsListName(): Array<string> {
      return Object.keys(this.tabsData);
    },
    showBackButton(): boolean {
      return this.tabIndex > 0 && this.tabIndex < this.tabsListName.length;
    },
    showNextButton(): boolean {
      return this.tabIndex < this.tabsListName.length - 1;
    },
  },

  methods: {
    backTabs(): void {
      if (this.tabIndex > 0) {
        this.changeTab(this.currentTab);
        this.tabIndex--;
        this.currentTab = this.tabsListName[this.tabIndex];
      }
    },
    nextTabs(): void {
      if (this.tabIndex < this.tabsListName.length - 1) {
        this.changeTab(this.currentTab);
        this.tabIndex++;
        this.currentTab = this.tabsListName[this.tabIndex];
      }
    },
    changeTab(tab: string): void {
      this.tabIndex = this.tabsListName.indexOf(tab);
      this.previosTab = this.currentTab;
      this.currentTab = tab;

      this.checkIsActivated(tab);

      if (!this.loadData) {
        this.$emit('changeTab', this.previosTab, this.currentTab);
      }
    },
    checkIsActivated(tab) {
      if (this.tabsName?.[tab]?.isActivated === false) {
        this.tabsName[tab].isActivated = true;
      }
    },
    setTabToUrl(tab: string): void {
      const urlParams = {
        tab,
      };
      filterParams.saveToUrlParams(urlParams);
      this.$emit('changeCurrentTab', this.currentTab);
    },
  },

  data() {
    return {
      previosTab: '' as string,
      currentTab: this.activeTab as string,
      tabIndex: 0 as number,
    };
  },
});
